import type { CreateTemplateRequestBody } from "@/common/types/templates";

import { useState } from "react";

import { createTemplate as createTemplateService } from "@/services/templates";

export const useCreateTemplate = (): {
  createTemplate: (body: CreateTemplateRequestBody) => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: boolean;
} => {
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const createTemplate = async (
    body: CreateTemplateRequestBody
  ): Promise<void> => {
    setLoading(true);
    setError(false);

    try {
      await createTemplateService(body);
      setResult(true);
      setLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  return { createTemplate, result, loading, error };
};
